import { Component, Input } from '@angular/core';

import { chartStatus } from '@src/constants';

@Component({
    selector: 'summary-environment',
    template: require('./summary-environment.component.html'),
    styles: [require('./summary-environment.component.scss')]
})
export class SummaryEnvironmentComponent {
    public name: string;
    public firstEnvironment: any;
    public icon: any = {};
    public envsData: any;

    @Input() public set data(value: any) {
        this.envsData = value;
        this.name = value.name;
        this.firstEnvironment = value.environments[0];
        if (this.firstEnvironment.status !== 0 && chartStatus[this.firstEnvironment.status]) {
            this.icon = chartStatus[this.firstEnvironment.status];
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/summary-environment/summary-environment.component.ts